// extracted by mini-css-extract-plugin
export default {"menu":"style_menu__NZ+6x","button":"style_button__LTeDC"};